'use client';

import useId from '@mui/utils/useId';
export default useId;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/useId.js
// module id = 262
// module chunks = 22